import { createSelector } from 'reselect';
import { filterNonGlobalConnectedAccounts } from 'conversations-thread-data/connected-accounts/public';
import { getAllConnectedAccounts } from './getAllConnectedAccounts';
export const getConnectedAccounts = createSelector([getAllConnectedAccounts], allConnectedAccounts => {
  return filterNonGlobalConnectedAccounts(allConnectedAccounts);
});
export default getConnectedAccounts;